// LanguageContext.js
import React, { createContext, useState, useContext, useEffect } from 'react'

// Create context
const LanguageContext = createContext()

// Provider component
export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('eng')
    const [isLoading, setIsLoading] = useState(true)

    // Load language from localStorage on initial render
    useEffect(() => {
        const savedLanguage = localStorage.getItem('usedLanguage')
        if (savedLanguage) {
            setLanguage(savedLanguage)
        } else {
            // Set default language and save to localStorage
            localStorage.setItem('usedLanguage', 'eng')
            setLanguage('eng')
        }
        setIsLoading(false)
    }, [])

    // Function to change language
    const changeLanguage = (lang) => {
        setLanguage(lang)
        localStorage.setItem('usedLanguage', lang)
    }

    // If still loading, show nothing or a loader
    if (isLoading) {
        return null
    }

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    )
}

// Custom hook to use language context
export const useLanguage = () => {
    const context = useContext(LanguageContext)
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider')
    }
    return context
}